import { render, staticRenderFns } from "./Rule59ApplicationInstructions.vue?vue&type=template&id=d72e620a&scoped=true"
import script from "./Rule59ApplicationInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule59ApplicationInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule59ApplicationInstructions.vue?vue&type=style&index=0&id=d72e620a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72e620a",
  null
  
)

export default component.exports